import React from 'react';
import PropTypes from 'prop-types';

import HeaderBar from 'components/account/VipDashboard/HeaderBar';
import PrimaryAddress from 'components/account/PrimaryAccountInfo/PrimaryAddress';
import PrimaryPayment from 'components/account/PrimaryAccountInfo/PrimaryPayment';
import NameEmailPassword from 'components/account/PrimaryAccountInfo/NameEmailPassword';
import GiftCardRedeem from 'components/account/PrimaryAccountInfo/GiftCardRedeem';
import RewardsOverview from 'components/account/PrimaryAccountInfo/RewardsOverview';
import css from 'styles/components/account/primaryAccountInfo.scss';
import marketplace from 'cfg/marketplace.json';

const PrimaryAccountInfo = ({ account, address, isVIPDashboard, payment, rewards, showAccountRewards, onUpdateGiftCardRedeemCode, onGiftCardRedeemSubmit, onRewardsEnrollClick }) => {
  const { customerInfo, giftCardBalance, giftCardRedeemCode, giftCardRedeemError, isGiftCardRedeemed, isGiftCardRedeemLoading } = account;
  const { name, email } = customerInfo;
  const { account: { hasGiftCards } } = marketplace;
  const { rewardsInfo } = rewards || {};
  const { consented, prime, spendPoints, spendPointsDollarValue } = rewardsInfo || {};

  return (
    <div className={css.container}>
      <div className={css.primaryAccountInfo}>
        <h2>Your Primary Account Information</h2>
        <div className={css.primaryInfoRow}>
          <PrimaryAddress address={address}/>
          <PrimaryPayment payment={payment}/>
          <NameEmailPassword email={email} name={name}/>
        </div>
      </div>
      {hasGiftCards && (
        <div className={css.giftCardRedeem}>
          <GiftCardRedeem
            giftCardBalance={giftCardBalance}
            giftCardRedeemCode={giftCardRedeemCode}
            giftCardRedeemError={giftCardRedeemError}
            isGiftCardRedeemed={isGiftCardRedeemed}
            isGiftCardRedeemLoading={isGiftCardRedeemLoading}
            onUpdateGiftCardRedeemCode={onUpdateGiftCardRedeemCode}
            onGiftCardRedeemSubmit={onGiftCardRedeemSubmit}/>
        </div>
      )}
      {isVIPDashboard && showAccountRewards && consented && rewards && (
        <div className={css.vipDashboard}>
          <h2>Your VIP Summary</h2>
          <HeaderBar
            isAccountOverview={true}
            isPrime={prime}
            spendPoints={spendPoints}
            spendPointsDollarValue={spendPointsDollarValue} />
        </div>
      )}
      {!isVIPDashboard && showAccountRewards && rewards && (
        <div className={css.rewardsOverview}>
          <RewardsOverview rewards={rewards} onRewardsEnrollClick={onRewardsEnrollClick}/>
        </div>
      )}
    </div>
  );
};

PrimaryAccountInfo.contextTypes = {
  testId: PropTypes.func
};

PrimaryAccountInfo.propTypes = {
  address: PropTypes.object,
  payment: PropTypes.object,
  account: PropTypes.object.isRequired,
  showAccountRewards: PropTypes.bool,
  onUpdateGiftCardRedeemCode: PropTypes.func.isRequired,
  onGiftCardRedeemSubmit: PropTypes.func.isRequired,
  onRewardsEnrollClick: PropTypes.func.isRequired
};

export default PrimaryAccountInfo;
